import { Dialog, DialogTitle, IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";
import CompanyForm from "./ViewCompanyDialog/components/CompanyForm";

type AddNewCompanyModalProps = {
  onClose: () => void;
};

const AddNewCompanyModal: React.FC<AddNewCompanyModalProps> = ({ onClose }) => {
  return (
    <Dialog open={true} fullWidth maxWidth="md" onClose={onClose}>
      <DialogTitle>Registrera ny underentreprenör</DialogTitle>

      <IconButton
        onClick={onClose}
        sx={{ position: "absolute", right: 8, top: 12, color: "grey.500" }}
      >
        <Close />
      </IconButton>

      <CompanyForm onClose={onClose} onSuccess={onClose} />
    </Dialog>
  );
};

export default AddNewCompanyModal;
